export const TYPES = {
  board: { label: 'Tablero / caja de medición', color: '#2878c7' },
  sensor: { label: 'Sensor ambiental', color: '#16877a' },
  machine: { label: 'Máquina / motor', color: '#bc7621' },
};
export const MAX_BLOCKS = 100;
export const CATALOG = [
  { variant: 'meter', type: 'board', label: 'Medidor eléctrico', size: [5, 7, 3] },
  { variant: 'cabinet', type: 'board', label: 'Tablero eléctrico', size: [8, 11, 4] },
  { variant: 'environment', type: 'sensor', label: 'Sensor ambiental', size: [4, 4, 2] },
  { variant: 'motor', type: 'machine', label: 'Motor', size: [10, 6, 6] },
];
export const DEFAULT_VARIANTS = { board: 'cabinet', sensor: 'environment', machine: 'motor' };
export const equipmentInfo = (block) => CATALOG.find(item => item.variant === (block.variant || DEFAULT_VARIANTS[block.type]));
export const clonePlan = (plan) => plan ? JSON.parse(JSON.stringify(plan)) : null;
export const createPlan = (name) => ({ version: 1, name: name.trim(), background: null, blocks: [] });
export const createBlock = (type, variant = DEFAULT_VARIANTS[type]) => ({
  id: window.crypto?.randomUUID?.() || `block-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  type, variant, name: CATALOG.find(item => item.variant === variant).label, x: 0, z: 0,
  width: CATALOG.find(item => item.variant === variant).size[0],
  height: CATALOG.find(item => item.variant === variant).size[1],
  depth: CATALOG.find(item => item.variant === variant).size[2], rotation: 0,
});
export const planeSize = (background) => background
  ? (background.width >= background.height ? [100, 100 * background.height / background.width] : [100 * background.width / background.height, 100])
  : [100, 100];
export const clampPosition = (value) => Math.round(Math.max(-50, Math.min(50, value)) * 100) / 100;

const fail = (message) => { throw new Error(message); };
const nameValue = (value) => typeof value === 'string' && value.trim().length > 0 && value.length <= 120;
export function validatePlan(value) {
  if (!value || value.version !== 1 || !nameValue(value.name) || !Array.isArray(value.blocks) || value.blocks.length > MAX_BLOCKS) fail('Formato de plano inválido (versión 1, nombre y hasta 100 bloques).');
  const ids = new Set();
  const blocks = value.blocks.map((b) => {
    if (!b || !Object.prototype.hasOwnProperty.call(TYPES, b.type) || !nameValue(b.name) || typeof b.id !== 'string' || !/^[a-zA-Z0-9_-]{1,80}$/.test(b.id) || ids.has(b.id)) fail('Bloque inválido: revisá tipo, nombre e identificador único.');
    ids.add(b.id);
    if (b.variant !== undefined && !CATALOG.some(item => item.type === b.type && item.variant === b.variant)) fail('Variante visual incompatible con el tipo de equipo.');
    const result = { id: b.id, type: b.type, name: b.name.trim() };
    if (b.deviceId != null && (!Number.isInteger(b.deviceId) || b.deviceId < 1 || b.deviceId > 2147483647)) fail('Dispositivo asociado inválido.');
    result.deviceId = b.deviceId ?? null;
    // Ausencia de variante conserva exactamente el esquema antiguo v1.
    if (b.variant !== undefined) result.variant = b.variant;
    for (const [key, min, max] of [['x', -50, 50], ['z', -50, 50], ['width', 0.5, 40], ['depth', 0.5, 40], ['height', 0.5, 40], ['rotation', -360, 360]]) {
      if (typeof b[key] !== 'number' || !Number.isFinite(b[key]) || b[key] < min || b[key] > max) fail(`Valor inválido de ${key}: debe estar entre ${min} y ${max}.`);
      result[key] = b[key];
    }
    return result;
  });
  if (value.background !== null && (!value.background || typeof value.background.dataUrl !== 'string' || !Number.isInteger(value.background.width) || !Number.isInteger(value.background.height) || value.background.width < 1 || value.background.height < 1 || value.background.width > 4096 || value.background.height > 4096)) fail('Fondo inválido: máximo 4096 × 4096 píxeles.');
  return { version: 1, name: value.name.trim(), background: value.background ? { dataUrl: value.background.dataUrl, width: value.background.width, height: value.background.height } : null, blocks };
}
